import * as React from "react"
const IconArrowRight = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? 14}
        height={props.height ?? 10}
        fill="none"
        viewBox="0 0 14 10"
        {...props}
    >
        <path
            stroke={props.stroke ?? "#413EE1"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={props.strokeWidth ?? 1.5}
            d="M1.167 5h11.667m0 0L9.5 8.333M12.834 5 9.5 1.667"
        />
    </svg>
)
export default IconArrowRight
